module.exports = __webpack_public_path__ + "static/media/gh-map-high-street.61b22572.png";